import { useCallback, useState } from 'react';
import http from '../../../../../http';

const orders = '/connex/services/orders';

const useCopyLocationMixes = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const copyLocationMixes = useCallback(async (entityRef, sourceLocation, copyLocations, onFinish) => {
    try {
      setError(null);
      setLoading(true);
      await http.post(`${orders}/${entityRef}/setup/mix/location/${sourceLocation}/copy`, { copyLocations });
      onFinish();
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }, []);

  return { loading, copyLocationMixes, error };
};

export default useCopyLocationMixes;
